import { render, staticRenderFns } from "./TopicSet.vue?vue&type=template&id=7e1306e4"
import script from "./TopicSet.vue?vue&type=script&lang=js"
export * from "./TopicSet.vue?vue&type=script&lang=js"
import style0 from "./TopicSet.vue?vue&type=style&index=0&id=7e1306e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports